import { Box, Table, Thead, Tbody, Tr, Th, Td, Spinner, Text, Link, Heading, useBreakpointValue, Center } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import api from "../../utils/axios";
import Pagination from "../Pagination"; // Import the Pagination component
import { formatNumber } from "../../utils/helper";

const DailyTop100ByMarks = () => {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 10; // Number of items to display per page
	const isMobile = useBreakpointValue({ base: true, md: false });

	useEffect(() => {
		const getBadges = async () => {
			try {
				const response = await api.get('/daily-top100');
				setData(response.data);
			} catch (error) {
				console.error("Error fetching badges:", error);
			} finally {
				setLoading(false);
			}
		};

		getBadges();
	}, []);

	const indexOfLastItem = currentPage * itemsPerPage;
	const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

	const paginate = (pageNumber) => setCurrentPage(pageNumber);

	const handleRowClick = (walletAddress) => {
		// Open the external link in a new tab
		window.open(`https://debank.com/profile/${walletAddress}?chain=scrl`, '_blank');
	};

	if (loading) {
		return (
			<Box textAlign="center" mt={10}>
				<Spinner size="xl" color='#FF684B' thickness="4px" />
				<Text mt={4}><Center><Spinner /></Center></Text>
			</Box>
		);
	}

	return (
		currentItems && currentItems.length > 0 &&
		<Box padding={4} width="100%" mt={2} mb={4}>
			<Heading fontSize="2xl" mb={2} textAlign="center">Top Daily Mark Gainers</Heading>
			<Box borderRadius="lg" padding={4} width="100%" maxW="700px" mx="auto">
				<Box overflowX="auto">
					<Table variant="simple" width="100%" fontSize="sm">
						<Thead>
							<Tr>
								<Th>Rank</Th>
								<Th>Address</Th>
								<Th isNumeric>Marks</Th>
							</Tr>
						</Thead>
						<Tbody>
							{currentItems.map((item, index) => (
								<Tr
									key={item.walletAddress}
									cursor="pointer"
									_hover={{ bg: "#FEEFDD" }} // Background color on hover
									onClick={() => handleRowClick(item.walletAddress)}
								>
									<Td><Text fontSize={"md"}>{indexOfFirstItem + index + 1}</Text></Td>
									<Td
										_hover={{
											".address": { color: "#FF684B" }
										}}
									>
										<Link className="address" isExternal>
											<Text fontSize={"md"}>
												{!isMobile
													? item.walletAddress
													: `${item.walletAddress.slice(0, 6)}...${item.walletAddress.slice(-4)}`}
											</Text>
										</Link>
									</Td>
									<Td isNumeric><Text fontSize={"md"}>+{formatNumber(item.difference)}</Text></Td>
								</Tr>
							))}
						</Tbody>
					</Table>
				</Box>
			</Box>

			{/* Pagination */}
			<Box mt={6} display="flex" justifyContent="center" flexWrap="wrap" gap={2}>
				<Pagination
					currentPage={currentPage}
					totalPages={Math.ceil(data.length / itemsPerPage)}
					onPageChange={paginate} // Here, we're passing paginate as onPageChange
				/>
			</Box>
		</Box>
	);
}

export default DailyTop100ByMarks;
